import { render, staticRenderFns } from "./AgeGroup.vue?vue&type=template&id=5fcbb7e7"
import script from "./AgeGroup.vue?vue&type=script&lang=js"
export * from "./AgeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports